import React, { useState } from "react";
import { useLocation } from "react-router";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

interface MenuItem {
  label: string;
  link?: string;
  children?: MenuItem[];
}

const MenuItems = ({ parentMenu }: { parentMenu: MenuItem[] }) => {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const navigate = useNavigate();

  const isPathActive = (path: string) => location.pathname === path;

  const handleClick = (route: string) => {
    navigate(route);
  };

  const toggleDropdown = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <ul className="flex flex-col sm:space-x-2 lg:flex-row lg:space-x-2 lg:w-full lg:items-center lg:justify-evenly lg:space-x-6">
      {parentMenu.map((menu, index) => (
        <li key={index} className="group relative w-full lg:w-auto">
          {menu.children ? (
            /* Button for items with sublinks */
            <button
              onClick={() => toggleDropdown(index)}
              className={`flex w-full items-center justify-between px-4 py-2 text-gray-800 hover:text-blue-600 lg:cursor-default ${
                isPathActive(menu.link || "")
                  ? "font-semibold text-blue-600"
                  : ""
              }`}
            >
              <span>{menu.label}</span>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`ml-2 text-xs transition-transform lg:group-hover:rotate-180 ${
                  activeIndex === index ? "rotate-180" : ""
                }`}
              />
            </button>
          ) : (
            /* Link for items without sublinks */
            <button
              onClick={() => handleClick(menu.link || "")}
              className={`flex w-full items-center justify-between px-4 py-2 text-gray-800 hover:text-blue-600 ${
                isPathActive(menu.link || "")
                  ? "font-semibold text-blue-600"
                  : ""
              }`}
            >
              {menu.label}
            </button>
          )}

          {/* Dropdown for Submenu */}
          {menu.children && (
            <ul
              className={`ml-2 flex flex-col pl-5 lg:invisible lg:absolute lg:left-0 lg:mt-2 lg:w-56 lg:overflow-hidden lg:rounded-md lg:bg-white lg:pl-0 lg:opacity-0 lg:shadow-lg lg:transition-all lg:duration-300 lg:group-hover:visible lg:group-hover:opacity-100 ${
                activeIndex === index ? "block" : "hidden"
              } lg:block`}
            >
              {menu.children.map((child, childIndex) => (
                <li key={childIndex} className="w-full">
                  <button
                    onClick={() => handleClick(child.link || "")}
                    className={`w-full px-4 py-2 text-left text-gray-700 hover:text-blue-600 lg:bg-white lg:hover:bg-gray-100 ${
                      isPathActive(child.link || "")
                        ? "font-semibold text-blue-600"
                        : ""
                    }`}
                  >
                    {child.label}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
};

export default MenuItems;
